module.exports = __webpack_public_path__ + "media/images/athletes/1424-976c87b3d55723a833fac7f4b177ac2a.png";